import React, { Fragment, useRef } from 'react';
import PropTypes from 'prop-types';
import InputFileRow from './components/InputFileRow';
import LinkButton from 'components/LinkButton';
import { FieldArray } from 'formik';

import BasicButton from 'components/BasicButton';

import './styles.css';

const InputFileGroup = props => {
  const {
    name,
    values = [],
    errors = [],
    touched = [],
    onChange,
    onRemove,
    showDescription = true,
    linkAsButton = false,
  } = props;

  const inputFile = useRef();

  const addFile = (e, arrayHelpers) => {
    if (e.target.files && e.target.files.length) {
      for (let i = 0; i < e.target.files.length; ++i) {
        arrayHelpers.push({ file: e.target.files[i], description: '' });
      }
      inputFile.current.value = '';
    }
  };

  const handleChange = (name, index, value, arrayHelpers) => {
    onChange &&
      typeof onChange === 'function' &&
      onChange(name, index, value, arrayHelpers);
  };

  const handleRemove = (index, arrayHelpers) => {
    onRemove && typeof onRemove === 'function' && onRemove(index, arrayHelpers);
  };

  const controlStyles = {
    maxWidth: linkAsButton ? '100%' : '200px',
    marginBottom: linkAsButton ? '5px' : '25px',
  };

  return (
    <FieldArray
      name={name}
      render={arrayHelpers => (
        <>
          <div
            className="form__group form__group--compact"
            style={controlStyles}
          >
            {linkAsButton ? (
              <div className="input-file-group__link">
                <LinkButton
                  text="Add File"
                  controlFunc={() => inputFile.current.click()}
                />
              </div>
            ) : (
              <BasicButton
                controlFunc={() => inputFile.current.click()}
                btnWidth={160}
                btnHeight={35}
                btnFontWeight={500}
                btnArrow={false}
                btnTextColor="#27282d"
                btnText="Add file"
              />
            )}

            <input
              ref={inputFile}
              multiple
              hidden
              type="file"
              onChange={e => addFile(e, arrayHelpers)}
            />
          </div>
          <div className="input-file-group">
            {values.map((value, index) => {
              const error =
                !!touched[index] && errors[index] ? errors[index] : null;

              return (
                <Fragment key={index}>
                  <InputFileRow
                    isValid={!error}
                    value={value}
                    index={index}
                    showDescription={showDescription}
                    onRemove={index => handleRemove(index, arrayHelpers)}
                    onChange={(index, value) =>
                      handleChange(name, index, value, arrayHelpers)
                    }
                  />
                  {error && (
                    <div className="input-file-group__error">{error}</div>
                  )}
                </Fragment>
              );
            })}
          </div>
        </>
      )}
    />
  );
};

InputFileGroup.propTypes = {
  name: PropTypes.string.isRequired,
  values: PropTypes.arrayOf(
    PropTypes.shape({
      file: PropTypes.object.isRequired,
      description: PropTypes.string,
    })
  ),
  errors: PropTypes.array,
  touched: PropTypes.array,
  onChange: PropTypes.func,
  onRemove: PropTypes.func,
};

export default InputFileGroup;
